module.exports = __webpack_public_path__ + "img/gemxyz.11572e0a.jpeg";